import React from 'react'
import styles from './kyc.module.scss';
import Button from '../../../../components/Button/Button';
function PersonalInformation({ formData, setActiveNav, handleInputChange }) {

    const handleFormSubmission = () => {
        if(formData.firstName && formData.lastName && formData.phoneNumber && formData.email){
            console.log('Form Data :', formData);
            setActiveNav(2)
        }
        else{
            console.log('Incomplete Form Data :', formData);
            console.log('Please Fill all the details!');
        }
    }

    return (
        <form action="">
            <div className={styles.inputField}>
                <label htmlFor="firstName">First Name</label>
                <input id='firstName' name='firstName' type="text" onChange={handleInputChange} value={formData.firstName} required />
            </div>

            <div className={styles.inputField}>
                <label htmlFor="lastName">Last Name</label>
                <input type="text" id='lastName' name='lastName' onChange={handleInputChange} value={formData.lastName} required />
            </div>

            <div className={styles.inputField}>
                <label htmlFor="phoneNumber">Phone Number</label>
                <input type="number" id='phoneNumber' name='phoneNumber' onChange={handleInputChange} value={formData.phoneNumber} required />
            </div>

            <div className={styles.inputField}>
                <label htmlFor="email">Email</label>
                <input id='email' type="email" name='email' onChange={handleInputChange} value={formData.email} required />
            </div>

            <div className={styles.btnContainer}>
                <Button label={'Next'} handleClick={handleFormSubmission} />
            </div>
        </form>
    )
}

export default PersonalInformation